module.exports = require("mdast-util-inject");


//////////////////
// WEBPACK FOOTER
// external "mdast-util-inject"
// module id = 45
// module chunks = 0 1 2 3 4 5 6 7 8 9 13